import React from "react";
import Modal from "../Modal/Modal";
import { TextLogsType } from "../../Pages/Admin/SearchLogs/SearchLogs";
import styles from "./TextLogModal.module.scss";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRowData: TextLogsType | null;
}

function TextLogModal(props: Props) {
  const { isOpen, setIsOpen, selectedRowData } = props;
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Text Log</h1>
        </div>
        <div className={styles.contentContainer}>
          {selectedRowData &&
            Object.keys(selectedRowData as TextLogsType).map((key, i) => {
              const typedKey = key as keyof TextLogsType;
              if (typedKey === "awsMessageResponse") {
                const prettyJson = JSON.stringify(
                  selectedRowData?.[typedKey],
                  null,
                  2
                );
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                    <pre className={styles.contentItemValue}>{prettyJson}</pre>
                  </div>
                );
              }
              return (
                <div className={styles.contentItem} key={i}>
                  <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                  <p className={styles.contentItemValue}>
                    {selectedRowData?.[typedKey]}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
}

export default TextLogModal;
